const translations = {
    active: 'Active'
};

export default translations;
